export default "__VITE_ASSET__Bx4X_Q1e__"